import axios from 'axios';
import {loginreq, req, reqJson} from './axiosFun';

// 系统管理 - 登录接口
export const login = (params) => {return reqJson("post", "/api/login", params)};
// 系统管理 - 退出接口
export const loginout = () => {return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data)};


// 用户管理-获取用户列表
export const userList = (params) => reqJson("post", "/api/user/profile/query/user/list", params);
// 用户管理-跑腿人员列表
export const courierList = () => reqJson("get", "/api/courier/list");
//用户管理 - 用户信息修改
export const userUpdate = (params => reqJson("post", "/api/user/profile/update", params));
//用户管理 - 认证状态变更
export const userStatusUpdate = (params => reqJson("post", "/api/user/profile/update/status", params));
//用户管理 - 封禁
export const ban = (params => reqJson("put", "/api/user/profile/ban", params));
//用户管理 - 解除封禁
export const unban = (params => reqJson("put", "/api/user/profile/unban/" + params.id));
//用户管理 - 删除
export const remove = (params => reqJson("post", "/api/user/profile/delete/" + params.id));
//用户管理 - 变更用户类型
export const updateAdminType = (params => reqJson("post", "/api/user/profile/updateAdminType/", params));
//用户管理 - 密码修改
export const updatePassword = (params => reqJson("post", "/api/updatePassword", params));




// WEBPACK FOOTER //
// ./src/api/userMG.js